import { render, staticRenderFns } from "./template.vue?vue&type=template&id=0c85c4bf&scoped=true&"
import script from "./template.vue?vue&type=script&lang=js&"
export * from "./template.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=0c85c4bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c85c4bf",
  null
  
)

export default component.exports